import React from "react";
import "../InhelerForm/InhelerForm.css";
import image1 from '../Assets/inhaler (1).png'
import { motion } from "framer-motion";

function InhelerForm() {
  return (
    <>
      <motion.div
            initial={{ x:0,  opacity:0}}
            transition={{ ease: "easeOut", duration: 4 }}
            whileInView={{ x: 0 , opacity:1}}   className="inheler-form">
        <div
            
            // animate={{ x: 100 }}
            className="inheler-form-div1">
          <h2>
          Focus on Inhaled dosage forms
            <hr />
          </h2>
          <p>
            Our scientists with proven track record utilize the latest
            instrumentation and methodologies to provide customers with the
            highest quality of analytical support for MDIs, DPIs, Nebulizers and
            Nasal drug products. We develop a program to meet all necessary
            requirements including stability storage conditions and determining
            the relevant experiments needed for country specfic industry
            guidelines. At the completion of each project, we provide customers
            with detailed reports ready for regulatory submission.
          </p>
        </div>
        <div className="inheler-form-div2">
        <div className="inheler-form-card inheler-form-card1">
        <img src={image1} alt="Metered Dose Inhaler" className="inheler-form-card-image"/>
            <p className="inheler-form-card-text">Metered Dose Inhaler</p>
        </div>
        <div className="inheler-form-card inheler-form-card2">
        <img src={image1} alt="Dry Powder Inhaler" className="inheler-form-card-image"/>
            <p className="inheler-form-card-text">Dry Powder Inhaler</p>
        </div>
        <div className="inheler-form-card inheler-form-card3">
            <img src={image1} alt="Nasal Spray" className="inheler-form-card-image"/>
            <p className="inheler-form-card-text">Nasal Spray</p>
            
        </div>
        </div>
      </motion.div>
    </>
  );
}
export default InhelerForm;
